"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const R = __importStar(require("ramda"));
const react_apollo_1 = require("react-apollo");
const auth_1 = require("@8base-react/auth");
const PermissionsContext_1 = require("./PermissionsContext");
const getPermissions_1 = require("./getPermissions");
const USER_PERMISSIONS_QUERY = graphql_tag_1.default `
  query UserPermissions {
    user {
      id
      permissions {
        items {
          resource
          resourceType
          permission
        }
      }
      roles {
        items {
          id
          name
        }
      }
    }
  }
`;
const TEAM_MEMBER_PERMISSIONS_QUERY = graphql_tag_1.default `
  query TeamMemberPermissions {
    teamMember {
      id
      permissions {
        items {
          resource
          resourceType
          permission
        }
      }
      roles {
        items {
          id
          name
        }
      }
    }
  }
`;
/**
 * Provider for 8base user permissions
 * @property {Function} children Children of the provider. Could be either react node or function with loading state.
 */
const PermissionsProvider = auth_1.withAuth(class PermissionsProvider extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderChildren = (args) => {
            const { children } = this.props;
            if (typeof children === 'function') {
                return children(args);
            }
            return children;
        };
        this.renderContent = ({ data, loading }) => {
            const { type = 'teamMember' } = this.props;
            const permissions = getPermissions_1.getPermissions(data, type);
            const roles = R.pipe(R.pathOr([], [type, 'roles', 'items']), R.map(({ name }) => name))(data);
            return (react_1.default.createElement(PermissionsContext_1.PermissionsContext.Provider, { value: { permissions, roles } }, this.renderChildren({ loading })));
        };
    }
    render() {
        const _a = this.props, { auth: { isAuthorized, authState }, children, type, customQuery } = _a, rest = __rest(_a, ["auth", "children", "type", "customQuery"]);
        return (react_1.default.createElement(react_apollo_1.Query, Object.assign({ query: customQuery || (type === 'user' ? USER_PERMISSIONS_QUERY : TEAM_MEMBER_PERMISSIONS_QUERY), skip: !isAuthorized || !authState.workspaceId }, rest), this.renderContent));
    }
});
exports.PermissionsProvider = PermissionsProvider;
//# sourceMappingURL=PermissionsProvider.js.map